import React, { createContext, useMemo } from 'react';
import { useToggles } from '../toggles/toggles.hook';
import { Context, Modelo, Props, Provider } from './modelo-apresentacao.types';

const key = 'sava.modelo-apresentacao';

export const ModeloApresentacaoContext = createContext<Context>(null);

export const ModeloApresentacaoProvider: Provider = ({ children }: Props) => {
  const { isEnabled } = useToggles();

  const search = useMemo(() => window.location.search, []);
  const origem = useMemo(() => new URLSearchParams(search).get('origem'), [search]);
  const DESATIVAR_APP_ALUNO = useMemo(() => isEnabled('DESATIVAR_APP_ALUNO'), [isEnabled]);

  const state = useMemo(() => {
    if (!DESATIVAR_APP_ALUNO && (/app_aluno/i.test(origem) || /app_aluno/i.test(localStorage.getItem(key)))) {
      const modelo: Modelo = 'APP_ALUNO';
      localStorage.setItem(key, modelo);
      return { modelo };
    }

    const modelo: Modelo = 'BROWSER';
    localStorage.setItem(key, modelo);

    return { modelo };
  }, [origem, DESATIVAR_APP_ALUNO]);

  return <ModeloApresentacaoContext.Provider value={state}>{children}</ModeloApresentacaoContext.Provider>;
};
